<template>
  <div>
    <div id="report-div">
      <v-divider></v-divider>
      <div style="margin-top:10px"></div>
      <v-row>
        <v-col sm12>
          <iframe
            :src="pdfFileLink"
            style="height:500px; width: 100%; border: none;"
          ></iframe>
        </v-col>
      </v-row>
      <v-flex>
        <v-menu>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" color="success" dark style="margin-right:10px;">
              <v-icon>file_download</v-icon>
              {{ $t("globals.download") }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="downloadExcel()">
              <v-list-item-title>
                {{ $t("components.getreports.excel") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="downloadPdf()">
              <v-list-item-title>
                {{ $t("components.getreports.pdf") }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-flex>
    </div>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../../components/ErrorHandler";

export default {
  components: {
    ErrorHandler,
  },
  name: "report-display",
  props: ["file", "pdfFileLink"],
  computed: {
    ...mapGetters("common", ["settings"]),
  },
  data: () => ({
    error: null,
  }),
  methods: {
    ...mapActions("data", ["fetchFile"]),
    downloadBlob(blob, filename) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      link.setAttribute("id", "link1");
      document.body.appendChild(link);
      link.click();
      var element = document.getElementById("link1");
      element.parentNode.removeChild(element);
    },
    async downloadPdf() {
      try {
        const response = await this.fetchFile({
          url: this.settings.APIURL + "pdfs/" + this.file.PDFName,
          filename: this.file.PDFName,
        });
        this.downloadBlob(new Blob([response.data]), this.file.PDFName);
      } catch (e) {
        this.error = e;
      }
    },
    async downloadExcel() {
      try {
        var response = await this.fetchFile({
          url: this.settings.APIURL + "excels/" + this.file.ExcelName,
          filename: this.file.ExcelName,
        });
        this.downloadBlob(new Blob([response.data]), this.file.ExcelName);
      } catch (e) {
        this.error = e;
      }
    },
  },
};
</script>
